export default __webpack_public_path__ + "static/media/TS3.e24a596a.png";